<script lang="ts">

    import { onMount } from "svelte";
    import { Circle } from 'svelte-loading-spinners'
    import { getContext } from 'svelte';
    
    const { close } = getContext('simple-modal');

	function sleep(ms) {
		return new Promise(resolve => setTimeout(resolve, ms));
	}

    let email: string;

    let emailError: string = "";
    let genericError: string = "";

    let header: HTMLElement;
    let submitting:boolean = false;

    let issuedReset:boolean = false;

    onMount(() => {
        let content = header.parentElement;
        let modalWindow = content.parentElement;
        let modalWindowWrap = modalWindow.parentElement;
        modalWindow.style.width = "30rem";
    });

    async function getEntitlement() {
        await sleep(5000);
        return fetch("/api/entitlements/get-new")
            .then(resp => resp.text());
    }
    
    function onSubmit() {
        if (submitting)
            return;

        // prevent double submit
        submitting = true;
        // clear out error texts
        emailError = "";
        genericError = "";
        
        if (!email) {
            // todo: status info
            emailError = "*Email is required"
            submitting = false;
        }
        else {
            let safeEmail = encodeURIComponent(email);

            getEntitlement().then(token => {
                var formData = new FormData();
                formData.append("email", safeEmail);
                formData.append("token", token);
                fetch("/api/account/forgot-password", { method: "POST", body: formData })
                    .then(resp => resp.text())
                    .then(data =>
                    {
                        // submission is done
                        submitting = false;

                        // ensure data has a value (404, 500, downtime, etc)
                        data = data || "Internal server error";

                        // lower case for simplicity
                        data = data.toLowerCase();

                        if (data.includes("error")) {
                            if (data.includes("internal")) {
                                genericError = "*Server error. Please try again later";
                            }
                            else if (data.includes("bad request")) {
                                genericError = "*Server error. Please try again later";
                            }
                            else if (data.includes("invalid email")) {
                                emailError = "*Invalid email";
                            }
                            else if (data.includes("with that email")) {
                                emailError = "*Couldn't find your account";
                            }
                        }
                        else {
                            issuedReset = true;
                        }
                        console.log(data);
                    });
            });
        }
    }

</script>

<h1 bind:this={header}>Change Password</h1>
<p>
    Use this form to change your password.
</p>
{#if !submitting && !issuedReset}
<form action="/" method="POST">
    <label class="error-label" for="email" name="email-error">{emailError}</label>
    <input name="email" bind:value={email} type="email" placeholder="Email" autocomplete="off" />
    <label class="error-label" for="submit" name="general-error">{genericError}</label>
    <input name="submit" type="submit" value="Request Password Reset" on:click|preventDefault={() => onSubmit() } />
</form>
{:else if submitting}
<div style="display: flex; align-items: center; justify-content: center">
    <Circle size="24" color="#131C18"></Circle>
</div>
{:else if issuedReset}
<div style="display: flex; flex-direction: column; align-items: center; justify-content: center">
    <hr style="border: none; border-top: 1px solid #00000033; width: 90%" />
    <p><strong>All set!</strong> Check your inbox <i>({email})</i> for instructions on how to reset your password.</p>
    <input on:click={() => close()} type="submit" value="✔">
</div>
{/if}

<style lang="scss">
    h1 {
        text-align: center;
        font-size: large;
    }
    p {
        text-align: center;
    }
    .error-label {
        align-self: flex-start;
        font-size: 14px;
        padding-left: 12px;
        color: red;
    }
    input {
        border: 1px solid #3c404422;
        margin: 14px;
        padding: 10px 12px;
        color: #3c4044;
        font-size: 16px;
        line-height: 26px;
        width: 90%;
        box-sizing: content-box;
    }
    input[type=submit] {
        cursor: pointer;
    }
    form {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }
    ::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
        color: #3c404460;
        opacity: 1; /* Firefox */
    }

    :-ms-input-placeholder { /* Internet Explorer 10-11 */
        color: #3c404460;
    }

    ::-ms-input-placeholder { /* Microsoft Edge */
        color: #3c404460;
    }
</style>